import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../../../Model/Combo/combo.service';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import * as XLSX from 'xlsx';
import { SessionService } from '../../../Util/Session/session.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';
@Component({
  selector: 'app-branch-holiday',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule],
  templateUrl: './branch-holiday.component.html',
  styleUrl: './branch-holiday.component.scss'
})
export class BranchHolidayComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  HolidayData: any[] = [];
  BranchData: any[] = [];
  filter = {
    SelectType: 3,
    Year: null as any,
  }
  HYear?: string
  Years = [] as any;
  public User: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private utility: UtilityService,
    private toast: ToastService,
    private sessionService: SessionService,
    private download: DownloadSampleService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.filter.Year = new Date().getFullYear();
    this.GetBranchHoliday();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetBranchHoliday() {
    this.isDisabled = true;
    this.holiday.GetBranchHoliday(this.filter).subscribe({
      next: (response) => {
        try {
          this.HolidayData = Object.values(response.Table)

          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  //Added By Pooja on 10th May 2024 As per discussion with Sakshi 
  handleFileInput(event: any): void {
    this.HolidayData.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }

  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueIds: Set<number> = new Set();
        
        this.BranchData = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};
          let hasError = false;

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          const id = rowData['ESS_BranchHolidayID'];
          const date = rowData['Date'];
          let holidayName = rowData['HolidayName'].toString();
          let BranchName = rowData['BranchName'].toString();
          let year = rowData['Year'];
          
          holidayName = holidayName ? holidayName.trim() : '';
          BranchName = BranchName ? BranchName.trim() : '';
          if (id !== 0 && uniqueIds.has(id)) {
            this.toast.show({ message: `Duplicate BranchHoliday ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (year.toString().length != 4 || year === '' || year === null || year === undefined) {
            this.toast.show({ message: `Invalid Year is at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (BranchName === '' || BranchName === null || BranchName === undefined) {
            this.toast.show({ message: `Branch name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (holidayName === '' || holidayName === null || holidayName === undefined) {
            this.toast.show({ message: `Holiday name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else if (typeof date !== 'string' || date === undefined || date === null) {
            this.toast.show({ message: `Date Format should be in 'DD MMM YYYY' at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          else {
            
            uniqueIds.add(id);
          }
          if (!hasError) {
            rowData['BranchName'] = BranchName
            rowData['HolidayName'] = holidayName;
            rowData['ESS_BranchHolidayID'] = id ?? '';
            this.BranchData.push(rowData);
          }
        }
        if (this.BranchData.length > 0) {
          this.BulkInsertUpdate(this.BranchData);
        }
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  BulkInsertUpdate(Data: any) {
    this.User = this.sessionService.GetUserDetails();
    if (this.BranchData.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const CompanyHolidayData = {
      SelectType: 'upload',
      ESS_BranchHolidayInsert: Data,
      UserId: this.User.UserId,
    };
    this.holiday.BulkBranchHolidayInsertUpdate(CompanyHolidayData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }

        window.location.reload();
      },
      error => {
        console.error('Error:', error);
      });
  }
  downloadExcel() {
    this.download.downloadExcel('BranchHolidayMaster');
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'BranchHolidayExcel',
      Year: this.filter.Year
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.BranchData = data;
        if (this.BranchData.length > 0) {
          this.download.exportToExcel(this.BranchData, "BranchHoliday_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}
